// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-dashboard {
  padding: 0.5rem 0 1rem;
}

::ng-deep .admin-dashboard-tabs .p-tabview-nav-link {
  padding: 12px 16px;
}
::ng-deep .admin-dashboard-tabs .admin-tab-icon {
  margin-right: 8px;
  font-size: 14px;
}
::ng-deep .admin-dashboard-tabs .p-tabview-panels {
  padding: 16px 0 0;
  background: transparent;
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard/admin-dashboard/admin-dashboard.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;AACF;;AAME;EACE,kBAAA;AAHJ;AAME;EACE,iBAAA;EACA,eAAA;AAJJ;AAOE;EACE,iBAAA;EACA,uBAAA;AALJ","sourcesContent":[".admin-dashboard {\n  padding: 0.5rem 0 1rem;\n}\n\n// The header template is rendered into PrimeNG's own nav DOM, so the icon spacing has to reach\n// it through ::ng-deep. Mirrors the .qa-tabview block in quality-assurance.component.scss so the\n// two tabbed pages in the portal look the same.\n::ng-deep .admin-dashboard-tabs {\n  .p-tabview-nav-link {\n    padding: 12px 16px;\n  }\n\n  .admin-tab-icon {\n    margin-right: 8px;\n    font-size: 14px;\n  }\n\n  .p-tabview-panels {\n    padding: 16px 0 0;\n    background: transparent;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
